export default defineAppConfig({
    ui: {
        /**
         * Design-System: Green-primary, Amber-accent
         * See Design Token System.html §04 for all AA/AAA contrast pairs.
         *
         * primary   → green  (green-700 #5e8024, 5.4:1 AA on white)
         * secondary → amber  (amber-600 #b87a2a, 4.6:1 AA on white)
         * error     → error  (error-600 #c06018, AA on white — replaces red completely)
         */
        colors: {
            primary: 'green',
            secondary: 'amber',
            neutral: 'neutral',
            success: 'green',
            info: 'info',
            warning: 'amber',
            error: 'error',
        },
        carousel: {
            slots: {
                dot: 'bg-neutral-100/50',
            },
            variants: {
                active: {
                    true: {
                        dot: 'data-[state=active]:bg-neutral-100',
                    },
                },
            },
        },
        button: {
            defaultVariants: {
                color: 'primary',
                variant: 'solid',
                size: 'xl',
            },
            compoundVariants: [
                {
                    color: 'primary',
                    variant: 'solid',
                    class: 'text-inverted bg-primary font-bold hover:bg-primary/75 active:bg-primary/75 disabled:bg-primary aria-disabled:bg-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
                },
                {
                    color: 'primary',
                    variant: 'outline',
                    class: 'ring bg-white ring-inset ring-primary/50 text-primary hover:bg-white/75 active:bg-primary active:text-white disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus:outline-none focus-visible:ring-2 focus-visible:ring-primary font-bold',
                },
                {
                    color: 'secondary',
                    variant: 'outline',
                    class: 'ring bg-white ring-inset ring-secondary/50 text-secondary hover:bg-white/75 active:bg-secondary active:text-white disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary font-bold',
                },
                {
                    color: 'secondary',
                    variant: 'solid',
                    class: 'text-inverted bg-secondary font-bold hover:bg-secondary/75 active:bg-secondary/75 disabled:bg-secondary aria-disabled:bg-secondary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary',
                },
            ],
        },
        container: {
            base: 'px-4 sm:px-6 lg:px-12',
        },
        modal: {
            slots: {
                title: 'text-4xl! pb-0!',
            },
        },
        pageSection: {
            slots: {
                description: 'font-bold',
                container: 'py-8 sm:py-10 lg:py-12',
            },
        },
    },
});
